/** Подстановки вида {цель} в шаблоне согласий: заполняются в конструкторе для каждой формы. */
export const placeholderPattern = /\{([^{}\n]{1,60})\}/g;
type WithTexts = { text: string; fullText?: string };
export function placeholdersOf(consent: WithTexts): string[] {
  return [...new Set([...`${consent.text}\n${consent.fullText ?? ''}`.matchAll(placeholderPattern)].map((m) => m[1]))];
}
/** Заменяет {name} на value во всех текстах согласия. */
export function fillPlaceholder<T extends WithTexts>(consent: T, name: string, value: string): T {
  const replace = (text: string) => text.split(`{${name}}`).join(value);
  return { ...consent, text: replace(consent.text), fullText: replace(consent.fullText ?? '') };
}
